import { render, staticRenderFns } from "./Permissions.vue?vue&type=template&id=5061af2e&"
import script from "./Permissions.vue?vue&type=script&lang=js&"
export * from "./Permissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports